import { Fruit, FruitType } from "./types";

export const FRUITS_DROP_TIMEOUT = 1000;

export const INTRO_DURATION = 7000;

export const RESULT_DURATION = 7000;

export const HINT_DURATION = 20000;

export const GAME_TIME = 30; // SECONDS

export const MAX_FALSE_CHOICES = 3;

export const DIABETES_FACTS = [
  "diabetes is manageable, early detection saves lives",
  "together we can fight diabetes with knowledge and care",
  "small steps in self care make a big difference in diabetes control",
  "The global number of people living with diabetes is expected to rise to 783 million by 2045",
  "patients living with type 2 diabetes face significant challenges, including comorbidities that affect the heart and circulation, liver and kidney.",
  "For all those living with diabetes, the continuous demands of disease management can significantly impact their quality of life.",
  "AstraZeneca’s vision for diabetes care is centered on holistic treatments addressing glycemic, cardiovascular, and renal health, driving better patient outcomes worldwide",
  "FORXIGA leads in Type 2 Diabetes care, offering essential cardiorenal protection from prevention to treatment. By reducing HbA1c and slowing CKD progression, FORXIGA helps patients achieve better outcomes.",
  "With up to 40% of Type 2 Diabetes (T2D) patients affected by Chronic Kidney Disease (CKD), AstraZeneca is focused on treatments that target both metabolic and renal protection to enhance patient outcomes.",
];

export const fruits: Fruit[] = [
  {
    id: 1,
    name: "Strawberries.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 2,
    name: "tuna.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 3,
    name: "Unsalted nuts.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 4,
    name: "White bread.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 5,
    name: "Whole grain bread.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 6,
    name: "Salmon.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 7,
    name: "Sausage.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 8,
    name: "Skinless chicken breast.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 9,
    name: "soda.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 10,
    name: "soda-2.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  // {
  //   id: 15,
  //   name: "Olive oil.png",
  //   clicked: false,
  //   type: FruitType.Healthy,
  // },
  // {
  //   id: 21,
  //   name: "Hot sauce.png",
  //   clicked: false,
  //   type: FruitType.Healthy,
  // },
  {
    id: 11,
    name: "Potatoes.png",
    clicked: false,
    type: FruitType.Healthy,
  },

  {
    id: 13,
    name: "salad.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 14,
    name: "Pickles.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },

  {
    id: 16,
    name: "Onion rings.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 17,
    name: "peaches.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 18,
    name: "French fries.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 19,
    name: "Fried Chicken.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 20,
    name: "full fat milk.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },

  {
    id: 22,
    name: "Instant noodles.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 23,
    name: "Ketchup.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 24,
    name: "Low fat Greek yogurt.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 25,
    name: "Low fat milk.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 26,
    name: "Oatmeal.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 27,
    name: "Canned Vegetables.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 28,
    name: "chips.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 29,
    name: "Chocolate drinks.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 30,
    name: "cookies.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 31,
    name: "Eggs.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 32,
    name: "fast food burgers.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 33,
    name: "bacon.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
  {
    id: 34,
    name: "berries.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 35,
    name: "Broccoli.png",
    clicked: false,
    type: FruitType.Healthy,
  },
  {
    id: 12,
    name: "candy.png",
    clicked: false,
    type: FruitType.Unhealthy,
  },
];
